export const aboutMe = {
  title: 'Perché scegliere me',
  differentiators: [
    {
      id: 'concrete-solutions',
      title: 'Il trattamento ti garantisce soluzioni concrete in breve tempo.',
      content: 'Il percorso inizia con un breve periodo di valutazione iniziale, durante il quale individueremo come funziona il tuo problema e come si mantiene; una volta terminata la valutazione inizieremo subito ad utilizzare tecniche per te efficaci che diano una risposta concreta nel minor tempo possibile.',
      metadata: {
        category: 'approach',
        order: 1
      }
    },
    {
      id: 'custom-treatment',
      title: 'Il trattamento viene sempre costruito su misura per te.',
      content: 'La psicoterapia, proprio come un abito di alta sartoria, viene costruita su misura per la persona; il percorso che intraprenderai con me sarà ideato per te e per rispondere alle tue specifiche esigenze.',
      image: 'about-1',
      layout: 'image-text',
      metadata: {
        category: 'personalization',
        order: 2
      }
    },
    {
      id: 'scientific-techniques',
      title: 'Utilizzo esclusivamente tecniche efficaci e scientificamente fondate.',
      content: 'Sono specializzato in psicoterapia cognitivo comportamentale, un modello di trattamento che si basa solo su tecniche la cui efficacia sia stata provata e validata scientificamente.',
      metadata: {
        category: 'methodology',
        order: 3
      }
    },
    {
      id: 'patient-care',
      title: 'Ho a cuore i miei pazienti.',
      content: 'La psicoterapia è il trattamento della persona e si fonda su relazioni umane: tengo tantissimo ai miei pazienti perché loro non sono solo un lavoro ma anche un valore umano.',
      image: 'about-2',
      layout: 'text-image',
      metadata: {
        category: 'relationship',
        order: 4
      }
    },
    {
      id: 'research-active',
      title: 'Sono sempre attivo nella ricerca e nella formazione.',
      content: 'La psicologia non è solo la mia professione ma anche la mia passione: mi impegno a mantenermi costantemente informato sul progredire del sapere scientifico di questa affascinante disciplina, attivandomi anche in prima persona tramite interventi in convegni nazionali e internazionali e tramite la pubblicazione di articoli.',
      metadata: {
        category: 'professional-development',
        order: 5
      }
    }
  ],
  personalIntro: {
    greeting: 'Ciao, sono Jacopo Biraschi',
    description: 'Sono uno psicologo clinico specializzato in psicoterapia cognitivo-comportamentale.',
    invitation: 'Ti invito a scoprire i servizi che offro e a contattarmi per parlarmi di te.',
    image: 'personal-photo',
    cta: {
      text: 'Contattami ora',
      action: 'contact-now'
    }
  },
  metadata: {
    section: 'about',
    personalApproach: true,
    languages: ['italian', 'english']
  }
};